<template>
    <div class="step email">
        <AdvSubTitle>{{ $t("common:signLog.adv.emailSubtitle") }}</AdvSubTitle>
        <AdvTitle class="mt-8" :class="[isMobileSize ? 'mb-10' : 'mb-32']"
        >{{ $t("common:signLog.adv.emailTitle") }}</AdvTitle
        >
        <AdvInput
            ref="input"
            v-bind="inputConfig"
            :value="value"
            @changeValue="changeValue"
        ></AdvInput>
        <AdvBtn
            class="mb-15"
            :class="[isMobileSize ? 'mt-10' : 'mt-24']"
            @click="handleNext"
        >{{ $t("common:signLog.adv.emailNext") }}</AdvBtn
        >
        <AdvDescript class="bt pb-30"
        >{{ $t("common:signLog.adv.emailDesc") }}
        </AdvDescript>
        <AdvProgress
            class="pt-34"
            :value="progress()"
            v-if="!isMobileSize"
        ></AdvProgress>
    </div>
</template>
<script>
import axios from 'axios';
import { REG_EMAIL } from '@/common/regexp';
import AdvBtn from './components/btn.vue';
import AdvDescript from './components/descript.vue';
import AdvInput from './components/input.vue';
import AdvProgress from './components/progress.vue';
import AdvSubTitle from './components/subTitle.vue';
import AdvTitle from './components/title.vue';
import common from './common';
export default {
    data: function() {
        return {
            inputConfig: {
                placeholder: 'Email Address',
                type: 'email',
                maxLength: 50,
                validator: this.validateEmail,
                errorMsg: 'Please enter a valid email address'
            },
            value: ''
        };
    },
    inject: ['progress', 'next'],
    computed: {
        isMobileSize() {
            return this.platform.isMobile
        },
    },
    methods: {
        changeValue(v) {
            this.value = v;
        },
        async handleNext() {
            let pass = await this.$refs.input._validate();
            if (pass) {
                this.next({ email: this.value });
            }
        },
        async validateEmail(val) {
            const reg = REG_EMAIL();
            if (!val.trim().length) {
                return Promise.reject({
                    errorInfo: this.$t('common:validate.fieldRequired')
                }); 
            }
            const error = { errorInfo: 'Email invalid' };
            if (!reg.test(val)) {
                return Promise.reject(error); 
            }
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api-site/register/hasUser?account=${val}`)
                    .then(res => {
                        // has user res.status.code = 210003
                        resolve(res?.status?.code == 0);
                    })
                    .catch(e => reject(e));
            });
        }
    },
    components: {
        AdvBtn,
        AdvDescript,
        AdvInput,
        AdvProgress,
        AdvSubTitle,
        AdvTitle
    },
    mixins: [common]
};
</script>
<style lang="scss"></style>
